import gql from 'graphql-tag'

export const NAME = 'updateClientsArchivedStatus'
const UPDATE_CLIENTS_ARCHIVED_STATUS_BY_USER_IDS = gql`
  mutation ${NAME}($ids: [ID!], $newArchivedStatus: Boolean!) {
    ${NAME}(ids: $ids, newArchivedStatus: $newArchivedStatus)
  }
`
export default UPDATE_CLIENTS_ARCHIVED_STATUS_BY_USER_IDS
